import { DashboardLateralNav } from 'components/DashboardLateralNav';
import { Navbar } from 'components/Navbar';
import { EmployeesProvider, ManagementProvider, ReportProvider } from 'context';
import { useCompanyHumanResourcesUser } from 'hooks/useUser';
import { Employee } from 'pages/HumanResources/Employee';
import { FC, useEffect, useState } from 'react';
import {
  Redirect,
  Route,
  Switch,
  useLocation,
  useRouteMatch,
} from 'react-router-dom';

import AssessmentIcon from '@mui/icons-material/Assessment';
import Diversity3Icon from '@mui/icons-material/Diversity3';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { Box, Container, Toolbar } from '@mui/material';

import { Management } from './Management';
import { Report } from './Report';

const MapRouteTitle = {
  '/employees': 'Colaboradores',
  '/management': 'Gerenciador',
  '/report': 'Relatório',
};

export const HumanResources: FC = () => {
  const { path } = useRouteMatch();
  const { pathname } = useLocation();
  const [items, setItems] = useState([{}]);
  const [openSideMenu, setOpenSideMenu] = useState(true);
  const [pageTitle, setPageTitle] = useState('Colaboradores');

  const { isSuperUser } = useCompanyHumanResourcesUser();

  const toggleDrawer = () => {
    setOpenSideMenu(!openSideMenu);
  };

  const getQueryTitle = () => {
    Object.entries(MapRouteTitle).forEach(([key, value]) => {
      if (pathname.search(key) >= 0) {
        setPageTitle(value);
      }
    });
  };

  useEffect(() => {
    getQueryTitle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(() => {
    if (isSuperUser) {
      setItems([
        {
          name: 'Colaboradores',
          url: `${path}/employees`,
          component: <Diversity3Icon />,
          route: '/employees',
        },
        {
          name: 'Gerenciador',
          url: `${path}/management`,
          component: <ManageAccountsIcon />,
          route: '/management',
        },
        {
          name: 'Relatório',
          url: `${path}/report`,
          component: <AssessmentIcon />,
          route: '/report',
        },
      ]);
    } else if (!isSuperUser) {
      setItems([
        {
          name: 'Colaboradores',
          url: `${path}/employees`,
          component: <Diversity3Icon />,
          route: '/employees',
        },
      ]);
    }
  }, [isSuperUser, path]);

  return (
    <Box sx={{ display: 'flex' }}>
      <DashboardLateralNav
        openSideMenu={openSideMenu}
        toggleDrawer={toggleDrawer}
        items={items}
        setPageTitle={setPageTitle}
      />
      <Navbar
        openSideMenu={openSideMenu}
        toggleDrawer={toggleDrawer}
        pageTitle={pageTitle}
      />
      <Box
        component="main"
        sx={{
          // backgroundColor: '#efefef',
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
        }}
      >
        <Toolbar />

        <Container sx={{ py: 3 }}>
          <Switch>
            {/* Employees */}
            <Route exact path={`${path}/employees`}>
              <EmployeesProvider>
                <Employee />
              </EmployeesProvider>
            </Route>

            {isSuperUser && (
              <>
                {/* Management  */}
                <Route exact path={`${path}/management`}>
                  <ManagementProvider>
                    <Management />
                  </ManagementProvider>
                </Route>
                {/* Report */}
                <Route exact path={`${path}/report`}>
                  <ReportProvider>
                    <Report />
                  </ReportProvider>
                </Route>
              </>
            )}

            <Redirect path={`${path}/dashboard`} to={`${path}/employees`} />
          </Switch>
        </Container>
      </Box>
    </Box>
  );
};
